import React from 'react';

const GoldChart = ({ symbol = "OANDA:XAUUSD" }) => {
  // بنعمل الرابط بتاع TradingView كصفحة جاهزة
  const baseUrl = "https://s.tradingview.com/widgetembed/?frameElementId=tradingview_762f2";
  const query = `&symbol=${symbol}&interval=D&hidesidetoolbar=1&hidetoptoolbar=1&symboledit=1&saveimage=1&toolbarbg=f1f3f6&studies=[]&theme=dark&style=3&timezone=Etc%2FUTC&studies_overrides={}&overrides={}&enabled_features=[]&disabled_features=[]&locale=ar&utm_source=localhost&utm_medium=widget&utm_campaign=chart&utm_term=${symbol}`;

  return (
    <div className="w-full h-full min-h-[350px] bg-[#0a0a0a] rounded-xl overflow-hidden">
      <iframe
        title={`Chart for ${symbol}`}
        width="100%"
        height="100%"
        src={baseUrl + query}
        frameBorder="0"
        allowTransparency="true"
        scrolling="no"
        allowFullScreen
      ></iframe>
    </div>
  );
};

export default GoldChart;